import React from "react";
import FollowUs from "../../../components/FollowUs/FollowUs";
import SubscriptionCard from "../../../components/SubscriptionCard/SubscriptionCard";

const SubscriptionSection = ({ margin }) => {
  return (
    <div className={`${margin} w-full flex justify-center items-center`}>
      <div className="w-[90%] sm:w-[85%] md:w-[80%] flex flex-col lg:flex-row justify-center items-center gap-3">
        <div className="w-full lg:w-1/2 self-stretch">
          <SubscriptionCard />
        </div>
        <div className="w-full lg:w-1/2 self-stretch">
          <FollowUs />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSection;
